import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, includes, map } from 'lodash';
import pagesCollection from '../../app-production-questions/data/pages';
import LightingForm from '../../app-production-questions/LightingForm';
import RulesForm from '../../app-production-questions/RulesForm';
import ElectricalForm from '../../app-production-questions/ElectricalForm';
import SoundForm from '../../app-production-questions/SoundForm';
import AccessForm from '../../app-production-questions/AccessForm';
import FaqContainerHOC from '../../app-faq-components/FaqContainerHOC';
import SideNav from '../../app-faq-components/SideNav';

const ProductionQuestionsContainer = ({ accessToken, space, page, listings }) => {
  const pages = map(pagesCollection, ({ page }) => page);
  const spaceID = get(space, 'data._id');

  if (!includes(pages, page)) {
    window.location.href = `/your-space/${spaceID}/production-faqs/lighting`;
    return null;
  }

  return (
    <div className="ps-row flex">
      <div className="col-xs-4" style={{ marginTop: '36px' }}>
        <SideNav
          page={page}
          spaceID={spaceID}
          linkPrefix="/your-space"
          urlSection="production-faqs"
          pagesCollection={pagesCollection}
          heading="Production FAQ"
        />
      </div>
      <div className="col-xs-8 margin-lg-top">
        <div className="flex-basis-50">
          { 'lighting' === page &&
            <LightingForm
              spaceId={spaceID}
              accessToken={accessToken}
              nextPage="sound"
              page={page}
            />
          }
          { 'sound' === page &&
            <SoundForm
              spaceId={spaceID}
              accessToken={accessToken}
              prevPage="lighting"
              nextPage="access"
              page={page}
            />
          }
          { 'access' === page &&
            <AccessForm
              spaceId={spaceID}
              accessToken={accessToken}
              prevPage="sound"
              nextPage="electrical"
              page={page}
            />
          }
          { 'electrical' === page &&
            <ElectricalForm
              spaceId={spaceID}
              accessToken={accessToken}
              prevPage="access"
              nextPage="rules"
              page={page}
            />
          }
          { 'rules' === page &&
            <RulesForm
              spaceId={spaceID}
              accessToken={accessToken}
              prevPage="electrical"
              nextPage="mylistings"
              page={page}
              listings={listings}
              disableButton={!get(listings, 'hasFetched')}
            />
          }
        </div>
      </div>
    </div>
  );
};

ProductionQuestionsContainer.propTypes = {
  listings: PropTypes.array,
  accessToken: PropTypes.string,
  page: PropTypes.string,
  space: PropTypes.object
};

export default FaqContainerHOC(ProductionQuestionsContainer);
